export default __webpack_public_path__ + "26c9b1d3d7943e6e67cf13e039ba5ac8.svg";